export default {
    // index: require("../plugins/ejs-emit-loader!../assets/index.xml.ejs"),
    about: require("../plugins/ejs-emit-loader!../assets/about.xml.ejs")
}